import Ajax from "@/api/ajax";
export default {
    //提交晒单
    submitUserReviews(params) {
        return Ajax.post("/Home/submitUserReviews", params);
    },
    //购物体验列表
    getUserReviewsList(params) {
        return Ajax.post("/Home/getUserReviewsList", params);
    },
    //体验详情
    userReviewsDetail(params) {
        return Ajax.post("/Home/userReviewsDetail", params);
    },
    //个人晒单
    userReviewsList(params) {
        return Ajax.post("/Home/userReviewsList", params);
    },
    //个人晒单
    getBargainOrderPay(params) {
        return Ajax.post("/Home/getBargainOrderPaymentInfo", params);
    },
    //我的留言
    getMessageOrder(params) {
        return Ajax.post("/Home/getMessageOrder", params);
    },
    //购物车
    setCartItemQuantity(params) {
        return Ajax.post("/Home/setCartItemQuantity", params);
    },
}